import React, { useMemo } from 'react';
import { AsYouType, getExampleNumber } from 'libphonenumber-js';
// eslint-disable-next-line import/extensions
import examples from 'libphonenumber-js/examples.mobile.json';
import { MarketField, MarketInputText } from '@market/react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { safeIsPossiblePhoneNumber } from 'typescript/utilities/phone';

const ControlledInputPhone = (props) => {
  const { t } = useTranslation();

  const {
    // fields used by Controller
    name,
    control,
    defaultValue,
    rules = {},
    shouldUnregister = false,

    // fields used by Market
    disabled = false,
    label,
    maxlength,
    minlength,

    store,
  } = props;

  // small hack because `required` doesn't doesn't do a whitespace check
  if (rules?.required) {
    rules.validate = {
      required: (value) => Boolean(value.trim()),
    };
  }

  rules.validate = {
    ...rules.validate,
    possible: (value) => safeIsPossiblePhoneNumber(value, store),
  };

  const placeholder = useMemo(() =>
    getExampleNumber(store, examples)?.formatNational(),
  );

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || ''}
      rules={rules}
      shouldUnregister={shouldUnregister}
      render={({
        field: { value, onChange },
        fieldState: { invalid, error },
        formState: { isSubmitting, isValidating },
      }) => (
        <MarketField
          {...((disabled || isSubmitting || isValidating) && {
            disabled: true,
          })}
          name={name}
          invalid={invalid}
        >
          <MarketInputText
            type="tel"
            name={name}
            value={value}
            placeholder={placeholder}
            // test to see if this is the max possible length for a phone number by "testing" +1 length
            maxlength={
              safeIsPossiblePhoneNumber(value, store) &&
              !safeIsPossiblePhoneNumber(`${value}1`, store)
                ? value.length
                : maxlength
            }
            minlength={minlength}
            onMarketInputValueChange={(e) => {
              const userInput = e.detail.value;
              let transformedInput = new AsYouType(store).input(userInput);
              if (transformedInput === value) {
                // this is a workaround to allow backspace
                // shamelessly stolen: https://gitlab.com/catamphetamine/react-phone-number-input/-/blob/master/source/InputBasic.js#L38-51
                if (transformedInput.indexOf(userInput) === 0) {
                  transformedInput = transformedInput.slice(0, -1);
                }
              }
              // eslint-disable-next-line no-param-reassign
              e.target.shadowRoot.querySelector('input').value =
                transformedInput;
              onChange(transformedInput);
            }}
          >
            {label && <label>{label}</label>}
          </MarketInputText>
          <small slot="error">
            {error?.message || t('error.validation.invalidPhone')}
          </small>
        </MarketField>
      )}
    />
  );
};

export default ControlledInputPhone;
